<div class="backdrop" (click)="onCancel()"></div>

<div class="slide-panel" role="dialog" aria-labelledby="feedback-form-title" (click)="$event.stopPropagation()">
  <div class="modal-container">
    <div class="form-banner">
      <img class="ban1" src="assets/images/formbanner1.svg" alt="" />
      <div class="banner-text">
        <h2 id="feedback-form-title" class="form-title">Send Feedback</h2>
        <p>Report an issue or share a suggestion</p>
      </div>
      <img class="ban2" src="assets/images/formbanner2.svg" alt="" />
      <button mat-stroked-button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-content">
      <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
        <div class="form-grid">
          <!-- Type -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label">
                Type <span class="required-asterisk">*</span>
              </label>
              <ng-select
                class="ng_select_custom feedback-ng-select feedback-form-select"
                [items]="typeOptions"
                bindLabel="label"
                bindValue="value"
                formControlName="type"
                [clearable]="false"
                [searchable]="false"
                appendTo="body"
                dropdownPosition="auto"
                placeholder=""
              >
              </ng-select>
            </div>
            @if (isFieldInvalid('type')) {
              <div class="mat-error">Please select type</div>
            }
          </div>

          <!-- Subject -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label">
                Subject <span class="required-asterisk">*</span>
              </label>
              <input
                type="text"
                formControlName="subject"
                class="form-input"
                [class.is-invalid]="isFieldInvalid('subject')"
                maxlength="200"
                autocomplete="off"
              />
            </div>
            @if (isFieldInvalid('subject')) {
              <div class="mat-error">
                @if (feedbackForm.get('subject')?.errors?.['required']) {
                  Please enter Subject
                } @else if (feedbackForm.get('subject')?.errors?.['minlength']) {
                  Subject must be at least 5 characters
                }
              </div>
            }
          </div>

          <!-- URL -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label">
                URL
              </label>
              <input
                type="text"
                formControlName="url"
                class="form-input"
                [class.is-invalid]="isFieldInvalid('url')"
                autocomplete="off"
              />
            </div>
            @if (isFieldInvalid('url')) {
              <div class="mat-error">
                Please enter a valid URL
              </div>
            }
          </div>

          <!-- Page menu -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label">
                Page Menu
              </label>
              <ng-select
                class="ng_select_custom feedback-ng-select feedback-form-select"
                [items]="pageMenus()"
                bindLabel="label"
                bindValue="name"
                formControlName="pageMenu"
                [clearable]="true"
                [searchable]="true"
                appendTo="body"
                dropdownPosition="auto"
                placeholder=""
              >
              </ng-select>
            </div>
          </div>

          <!-- Page sub menu -->
          @if (hasSubMenus()) {
            <div class="form-field">
              <div class="form_field_wrapper">
                <label class="floating_label">
                  Page Sub Menu
                </label>
                <ng-select
                  class="ng_select_custom feedback-ng-select feedback-form-select"
                  [items]="subMenus()"
                  bindLabel="label"
                  bindValue="to"
                  formControlName="pageSubMenu"
                  [clearable]="true"
                  [searchable]="true"
                  appendTo="body"
                  dropdownPosition="auto"
                  placeholder=""
                >
                </ng-select>
              </div>
            </div>
          }

          <!-- Description -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label">
                Description
              </label>
              <app-editor-rich-text
                formControlName="description"
                placeholder="Enter description"
                class="rich-text-editor"
                [class.is-invalid]="isFieldInvalid('description')"
                [class.is-valid]="!isFieldInvalid('description') && feedbackForm.get('description')?.touched"
                [showFileUpload]="true"
                [allowLocalFileUpload]="true"
                (localFilesSelected)="onEditorFilesSelected($event)"
              ></app-editor-rich-text>
            </div>
            @if (isFieldInvalid('description')) {
              <div class="mat-error">
                @if (feedbackForm.get('description')?.errors?.['maxlength']) {
                  Description must be at most 2000 characters
                }
              </div>
            }
          </div>

          <!-- Media uploads -->
          <div class="form-field">
            <div class="form_field_wrapper">
              <label class="floating_label document-label">
                Image / Video
              </label>
            </div>
            <div
              class="document-upload-area"
              [class.drag-over]="isDragOver()"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
            >
              <input
                type="file"
                id="feedback-media-upload"
                class="file-input"
                accept="image/*,video/*"
                (change)="onFileSelected($event)"
              />
              <label for="feedback-media-upload" class="upload-button">
                <mat-icon>cloud_upload</mat-icon>
                <span class="upload-text">Add image or video</span>
                <span class="upload-hint">Click to browse file (max 25MB)</span>
              </label>
            </div>

            @if (selectedFiles().length > 0) {
              <div class="uploaded-documents">
                <div class="document-list">
                  @for (file of selectedFiles(); track file.name + '-' + file.size) {
                    <div class="document-item">
                      @if (isImageFile(file)) {
                        <div class="file-preview">
                          <img [src]="getImagePreview(file)" [alt]="file.name" class="image-preview" />
                        </div>
                      } @else if (isVideoFile(file)) {
                        <mat-icon class="file-icon">videocam</mat-icon>
                      } @else {
                        <mat-icon class="file-icon">insert_drive_file</mat-icon>
                      }
                      <div class="file-info">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{ getFileSize(file) }}</span>
                      </div>
                      <button
                        type="button"
                        mat-icon-button
                        class="remove-btn"
                        (click)="removeFile(file)"
                        aria-label="Remove file"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </form>
    </div>

    <div class="btn-group">
      <button type="button" class="btn-save" (click)="onSubmit()" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
          <app-spinner [size]="16" class="spinner"></app-spinner>
        } @else {
          <span>Submit Feedback</span>
        }
      </button>
      <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSubmitting()">
        Cancel
      </button>
    </div>
  </div>
</div>
